import React, { FunctionComponent } from "react";
import styled from "styled-components";
import Tooltip from "@xfrontend/xui-react-plus/lib/esm/components/tooltip/Tooltip";

const BarWrap = styled.div`
  gap: 2px;
  width: 100%;
  display: flex;
`;

const BarSegment = styled.div<{ $bg: string; $isFirst: boolean; $isLast: boolean }>`
  height: 10px;
  opacity: 0.7;
  background-color: ${(props: { $bg: string }) => props.$bg};
  width: 100%;
  border-top-left-radius: ${(props: { $isFirst: boolean }) => (props.$isFirst ? "2px" : "0")};
  border-bottom-left-radius: ${(props: { $isFirst: boolean }) => (props.$isFirst ? "2px" : "0")};
  border-top-right-radius: ${(props: { $isLast: boolean }) => (props.$isLast ? "2px" : "0")};
  border-bottom-right-radius: ${(props: { $isLast: boolean }) => (props.$isLast ? "2px" : "0")};

  &:hover {
    opacity: 1;
    cursor: pointer;
  }
`;

interface Item {
  value: number;
  bg: string;
  label: string;
}

interface Props {
  list: Item[];
  total: number;
}

const PercentageBar: FunctionComponent<Props> = (props) => {
  const { list = [], total } = props;
  const filtered = list.filter((item) => (item?.value ?? 0) > 0);
  const zeroStyle = {
    width: "100%", backgroundColor: "var(--x-purple-600)", height: "10px", borderRadius: "2px", opacity: 0.7,
  };

  return (
    <BarWrap>
      {filtered.length === 0 ? (
        <div style={zeroStyle} />
      ) : filtered.map((item, index) => (
        <div
          key={item.label}
          style={{
            width: `${(item.value / total) * 100}%`,
            minWidth: 0, // Allow shrinking if gap causes overflow
          }}
        >
          <Tooltip
            overlayComponent={(
              <div>
                {item?.label}
                {" "}
                :
                {item?.value}
              </div>
            )}
          >
            <BarSegment
              $bg={item.bg}
              $isFirst={index === 0}
              $isLast={index === filtered.length - 1}
            />
          </Tooltip>
        </div>
      ))}
    </BarWrap>
  );
};

export default PercentageBar;
